import type ApiService from '@nxt-insurance/api-service'
import { SupportedMarketKey } from '@nxt-insurance/constants'

import email_and_name from '@flows/configs/common/steps/email_and_name'
import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const household_at_contact_details = (apiService: ApiService) =>
  ({
    ...email_and_name({
      market: SupportedMarketKey.At,
      apiService,
    }),
    subFlow: SubFlow.Common,
    nextStep: HOUSEHOLD_STEPS.household_at_personal,
  }) as const satisfies AnyStepConfiguration

export default household_at_contact_details
